export default __webpack_public_path__ + "static/imperfect-foods-logo-white-ea4158f1392ec130a3d70adbc9c829e8.svg";